let AllEnvApiUrls = {
  production: {
    baseUrl: process.env.REACT_APP_PROD_COMPANY_API_URL,
  },
  staging: {
    baseUrl: process.env.REACT_APP_STAG_COMPANY_API_URL,
  },
  development: {
    baseUrl: process.env.REACT_APP_DEV_COMPANY_API_URL,
  },
};

const ApiUrls = AllEnvApiUrls[process.env.REACT_APP_ENVIRONMENT];
console.log("ApiUrls", ApiUrls);
console.log("process.env.REACT_APP_ENVIRONMENT", process.env.REACT_APP_ENVIRONMENT);
const CompanyAuthUrl = `${ApiUrls?.baseUrl}/company-service/v1`;

export const COMPANY_URLS = {
  // Auth API's
  login: `${CompanyAuthUrl}/auth/login`,
  register: `${CompanyAuthUrl}/auth/register`,
  forgetPassword: `${CompanyAuthUrl}/auth/forget-password`,
  logout: `${CompanyAuthUrl}/auth/logout`,
  change_password: `${CompanyAuthUrl}/auth/change-password`,

  // Company profile API's
  companyDetail: `${CompanyAuthUrl}/company/companyDetail`,
  get_profile: `${CompanyAuthUrl}/company/profile`,
  create_profile: `${CompanyAuthUrl}/company/profile`,
  update_profile: `${CompanyAuthUrl}/company/profile`,
  companyImage: `${CompanyAuthUrl}/company/companyImage`,
  getIndustryType: `${CompanyAuthUrl}/company/getIndustryType`,

  // Job-post API
  create_job_post: `${CompanyAuthUrl}/company/job-post`,
  getAllJobs: `${CompanyAuthUrl}/company/getAllJobs`,
  jobClosed: `${CompanyAuthUrl}/company/jobClosed`,
  getSingleJob: `${CompanyAuthUrl}/company/getSingleJob`,
  getJoblist: `${CompanyAuthUrl}/company/getJoblist`,
  getSkillslist: `${CompanyAuthUrl}/company/getSkillslist`,
  candidatesAppliedStatus: `${CompanyAuthUrl}/company/candidatesAppliedStatus`,
  download_resume: `${CompanyAuthUrl}/company/download-resume`,
  jobNotificationOnOff: `${CompanyAuthUrl}/company/jobPostNotificationOnOff`,
  changeNotificationSetting: `${CompanyAuthUrl}/company/changeNotificationSetting`,

  // Notification
  saveFcmToken: `${CompanyAuthUrl}/fcmToken/fcmDeviceToken`,
  deleteFcmToken: `${CompanyAuthUrl}/fcmToken/fcmDeviceToken`,
  getNotification:`${CompanyAuthUrl}/fcmToken/getNotifications`,
  readNotification:`${CompanyAuthUrl}/fcmToken/readNotification`,
  readAllNotifications:`${CompanyAuthUrl}/fcmToken/readAllNotifications`,
  sendNotification:`${CompanyAuthUrl}/fcmToken/sendNotification`,
  deleteNotificationById: `${CompanyAuthUrl}/fcmToken/deleteNotification`,
  deleteAllNotification: `${CompanyAuthUrl}/fcmToken/deleteNotification`,

  // Help and Support
  queryToAdmin: `${CompanyAuthUrl}/company/queryToAdmin`,

  // City API
  getCompnayCity: `${CompanyAuthUrl}/country/getcities`,
  getPhoneCode: `${CompanyAuthUrl}/country/getCountryCodes`,

  //payment
  getAllMonthlyPlans: `${CompanyAuthUrl}/payment/getAllMonthlyPlans`,
  newPayment: `${CompanyAuthUrl}/payment/newPayment`,
  checkStatus: `${CompanyAuthUrl}/payment/checkStatus`,
  buyPlan: `${CompanyAuthUrl}/payment/buyPlan`,
  getAllPayment:`${CompanyAuthUrl}/payment/getAllPayment`,
  getActivePlan:`${CompanyAuthUrl}/payment/activePlan`,
  downloadPdf:`${CompanyAuthUrl}/payment/downloadPdf`
};

